module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "to": "/settings/home",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Settings")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/settings/locations",
      "flat": ""
    }
  }, [_vm._v("Spaces")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/settings/profile",
      "flat": ""
    }
  }, [_vm._v("Profile")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "href": "https://settings.appointmentguru.co",
      "target": "_blank",
      "color": "primary"
    }
  }, [_vm._v("\n      Advanced settings\n      "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "grey lighten-4"
  }, [_c('v-card-text', [_c('v-alert', {
    staticClass: "pa-1",
    attrs: {
      "dismissible": "",
      "value": (_vm.currentPage === "Spaces"),
      "type": "info"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "target": "_blank",
      "dark": "",
      "href": "https://book.appt.guru/?p=1",
      "small": "",
      "outline": ""
    }
  }, [_vm._v("Book a consultation\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "target": "_blank",
      "dark": "",
      "href": "https://www.loom.com/share/c264dda3a91a4f37a2a0f57132ca3bad",
      "small": "",
      "outline": ""
    }
  }, [_vm._v("Watch a video\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("ondemand_video")])], 1), _vm._v("\n        Need help setting up your account?"), _c('br'), _vm._v("\n        Book a one on one session with us to help you get the most out of AppointmentGuru\n      ")], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "default": "Profile",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bea09ae6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Settings.vue
// module id = 1516
// module chunks = 9